<template>
	<div class="selected-filter">
		<div v-if="(!isDeleteAll && filter) || groups" class="selected-filter__name">
			<span v-if="filtersData && filter && filtersData?.find((f) => f.filterName === filter?.parameter.name)?.title">
				{{
					i18nService.$tDynamic(
						'modules.cars_module.cars.filters',
						filtersData.find((f) => f.filterName === filter?.parameter.name)?.title || '',
					)
				}}:
			</span>
			<span v-else> {{ filter ? filter.parameter.name : $t('modules.cars_module.filters.single_filter_selected.car_category') }}: </span>
		</div>
		<div v-if="priceRange" class="selected-filter__name">{{ $t('modules.cars_module.filters.single_filter_selected.price_per_day') }}:</div>
		<ButtonCustom
			v-else-if="isDeleteAll"
			class="selected-filter__pill selected-filter__pill--delete"
			iconAfter="close"
			@click="urlFiltersRef.clearFilters()"
			>{{ $t('modules.cars_module.filters.single_filter_selected.clear_all') }}</ButtonCustom
		>
		<div v-if="!isDeleteAll && filter && filter.parameter.name !== 'Seats' && !groups" class="selected-filter__pills">
			<ButtonCustom
				v-for="(value, i) in filter.values"
				:key="i"
				class="selected-filter__pill"
				iconAfter="close"
				@click="handleRemoveFilterValue(filter, value)">
				{{ typeof value === 'string' ? i18nService.$tDynamic('data.group_map_translations', parametersMapTranslations[value]) : value }}
			</ButtonCustom>
		</div>
		<div v-else-if="filter && filter.parameter.name === 'Seats'" class="selected-filter__pills">
			<ButtonCustom class="selected-filter__pill" iconAfter="close" @click="urlFiltersRef.setSeatsMin(null)">{{ filter.min }}+</ButtonCustom>
		</div>
		<div v-else-if="groups" class="selected-filter__pills">
			<ButtonCustom
				v-for="(value, i) in groups"
				:key="i"
				class="selected-filter__pill"
				iconAfter="close"
				@click="urlFiltersRef.toggleArrayFilter('group', value.name)">
				{{
					typeof value.name === 'string'
						? i18nService.$tDynamic('data.group_map_translations', groupMapTranslations[value.name])
						: value.name
				}}
			</ButtonCustom>
		</div>
		<div v-else-if="priceRange" class="selected-filter__pills">
			<ButtonCustom class="selected-filter__pill" iconAfter="close" @click="urlFiltersRef.setPriceRange(null, null)">{{
				priceRange.name
			}}</ButtonCustom>
		</div>
	</div>
</template>

<script setup lang="ts">
import type { ISingleFilterProps } from '../SingleFilter.vue'
import { EFilterNames } from '@/modules/carsModule/types/filters'
import type { useUrlFilters } from '@/modules/carsModule/composables/useUrlFilters'

defineProps<{
	isDeleteAll?: boolean
	groups?: IProductGroupModel[]
	priceRange?: IPriceRange
	filter?: ICarSelectedFilters
	filtersData?: ISingleFilterProps[]
}>()

const i18nService = usei18nService()
const urlFiltersRef = inject<ReturnType<typeof useUrlFilters>>('urlFilters')!

function handleRemoveFilterValue(filter: ICarSelectedFilters, value: string | number) {
	const paramName = filter.parameter.name

	if (paramName === EFilterNames.TRANSMISSION) {
		urlFiltersRef.toggleArrayFilter('transmission', String(value))
	} else if (paramName === EFilterNames.FUEL_TYPE) {
		urlFiltersRef.toggleArrayFilter('fuel_type', String(value))
	}
}
</script>

<style lang="scss" scoped src="./Selected.scss"></style>
